"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var memoize = require("lodash.memoize");
var index_1 = require("./index");
var defaultLocaleObject = { language: 'ko', script: null, region: null };
var emptyObject = {};
var getState = memoize(function (locale, translations) { return ({
    locale: locale,
    translations: translations,
}); });
var wrapPageElement = function (_a) {
    var element = _a.element, pageContext = _a.props.pageContext;
    var _b = pageContext || emptyObject, _c = _b.locale, locale = _c === void 0 ? defaultLocaleObject : _c, _d = _b.translations, translations = _d === void 0 ? emptyObject : _d;
    return (React.createElement(index_1.i18nContext.Provider, { value: getState(locale, translations) }, element));
};
exports.default = wrapPageElement;
